import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledLogo, StyledRestLuxLogo } from './LuxLogo.styles';

interface ILuxLogoProps {
  open: boolean;
}

const LuxLogo: React.FC<ILuxLogoProps> = ({ open }) => {
  const navigate = useNavigate();
  const [_internalOpen, setInternalOpen] = useState(open);
  const [transition, setTransition] = useState(false);

  useEffect(() => {
    if (open === _internalOpen) return;
    if (open) {
      setInternalOpen(open);
    } else {
      setTransition(true);
      setTimeout(() => {
        setTransition(false);
        setInternalOpen(open);
      }, 1000);
    }
  }, [open]);

  const handleOnClick = useCallback(() => {
    navigate('/');

    document.dispatchEvent(new CustomEvent('LUX_CORE_ROUTE_TRIGGER', { detail: { path: '/' } }));
  }, [navigate]);

  return (
    <div className="logo-wrapper" onClick={handleOnClick}>
      <StyledLogo />
      {_internalOpen && <StyledRestLuxLogo className={transition ? 'lux-logo-animate-out' : ''} />}
    </div>
  );
};

export default LuxLogo;
